import { render, staticRenderFns } from "./CropImage.v2.vue?vue&type=template&id=c79c6204&scoped=true&"
import script from "./CropImage.v2.vue?vue&type=script&lang=js&"
export * from "./CropImage.v2.vue?vue&type=script&lang=js&"
import style0 from "./CropImage.v2.vue?vue&type=style&index=0&id=c79c6204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79c6204",
  null
  
)

export default component.exports